// Link de seguimiento que el staff captura A MANO en la lista de pedidos, para
// los delivery que NO van con Uber Direct: otra plataforma (Rappi, DiDi…) o un
// repartidor local. **Es OPCIONAL**: con repartidor propio no hay link y el
// pedido pasa igual a "En ruta" (reporte de la operación, 2026-09-07).
//
// Se normaliza porque la web lo abre con `window.open(order.routeUrl)`: sin
// esquema, el navegador lo resolvería relativo a app.krispis.mx y el cliente
// vería una página rota.
export const normalizeRouteUrl = (input?: string | null): string | undefined => {
    const value = (input ?? '').trim();
    if (!value) return undefined;
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) return value;
    return `https://${value}`;
};
